import { Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';

import en from '@@i18n/en.json';
import { MapProvider } from '@american-autonomy/rantizo-ui';
import { MantineProvider } from '@mantine/core';

import { DeviceProvider } from 'components/DeviceProvider';
import FeatureProvider from 'components/FeatureProvider';
import GlobalStoreProvider from 'components/GlobalStoreProvider';
import HotJar from 'components/HotJar';

import AppRoutes from './AppRoutes';
import { AppTheme } from './AppTheme';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

export const App: FunctionComponent<Props> = ({ testId = TEST_ID }) => (
    <GlobalStoreProvider>
        <HotJar testId={testId}>
            <IntlProvider defaultLocale="en" locale="en" messages={en}>
                <DeviceProvider deskWidthPx="769px">
                    <MantineProvider
                        theme={AppTheme}
                        withCSSVariables
                        withGlobalStyles
                        withNormalizeCSS
                    >
                        <FeatureProvider>
                            <MapProvider apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY}>
                                <Router>
                                    <Suspense fallback={<div>Loading...</div>}>
                                        <AppRoutes />
                                    </Suspense>
                                </Router>
                            </MapProvider>
                        </FeatureProvider>
                    </MantineProvider>
                </DeviceProvider>
            </IntlProvider>
        </HotJar>
    </GlobalStoreProvider>
);
